import { render, staticRenderFns } from "./NewsRow.vue?vue&type=template&id=06298c1e&scoped=true&"
import script from "./NewsRow.vue?vue&type=script&lang=js&"
export * from "./NewsRow.vue?vue&type=script&lang=js&"
import style0 from "./NewsRow.vue?vue&type=style&index=0&id=06298c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06298c1e",
  null
  
)

export default component.exports